// extracted by mini-css-extract-plugin
export default {"poster":"style_poster__6Cpwk","title":"style_title__9vtET","bg":"style_bg__+d47y"};